// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss } from "@vanmeter/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridItem from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import Link, { LinkPresentationProps } from "@vanmeter/MobiusOverrides/Link/Link";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
    extendedStyles?: CardListHeadingStyles;
    // XNG-Changes
    viewAllLabel?: string;
}

// XNG-Change add styles
export interface CardListHeadingStyles {
    wrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    viewAllLink?: LinkPresentationProps;
}

export const cardListHeadingStyles: CardListHeadingStyles = {};

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl, extendedStyles, viewAllLabel }) => {
    const [styles] = React.useState(() => mergeWithCss(cardListHeadingStyles, extendedStyles));

    return (
        // XNG-Change structure
        <StyledWrapper {...styles.wrapper}>
            <Typography className="card-list-heading" {...styles.title}>
                {heading}
            </Typography>
            {viewAllUrl && (
                <Link
                    href={viewAllUrl}
                    className="view-all-link"
                    data-test-selector="cardListHeadingViewAllLink"
                    {...styles.viewAllLink}
                    aria-label={translate(viewAllLabel || "View All")}
                >
                    {translate(viewAllLabel || "View All")}
                    <VisuallyHidden>
                        {translate("View All")} {heading}
                    </VisuallyHidden>
                </Link>
            )}
        </StyledWrapper>
    );
};

export default CardListHeading;
